const addProject = (project) => {
  const projectRoot = document.querySelector(".project-wrapper");

  const row = document.createElement("div");
  row.classList.add("row");

  // ******************************* ADD PROJECT TEXT & BUTTONS *******************************
  {
    const colTextAndButtons = document.createElement("div");
    colTextAndButtons.classList.add("col-sm-12");
    colTextAndButtons.classList.add("col-lg-4");

    // ******************************* CREATE PROJECT WRAPPER *******************************
    const projectTextWrapper = document.createElement("div");
    {
      projectTextWrapper.classList.add("project-wrapper__text");
      projectTextWrapper.classList.add("load-hidden");
    }

    // ******************************* CREATE PROJECT TITLE *******************************
    const title = document.createElement("h3");
    {
      title.classList.add("project-wrapper__text-title");
      title.innerText = project.title;
    }

    // ******************************* CREATE PROJECT DESCRIPTION *******************************
    const description = document.createElement("p");
    {
      description.classList.add("justify");
      description.innerText = project.description;
    }

    // ******************************* CREATE PROJECT HIGHLIGHTS *******************************
    const highlights = document.createElement("p");
    {
      highlights.classList.add("mb-4");

      const isHighlightsSingular = project.highlights.split(",").length === 1;
      const highlightsTitle = document.createElement("span");
      highlightsTitle.innerText = `Highlight${
        isHighlightsSingular ? "" : "s"
      }: `;
      highlightsTitle.classList.add("highlights-title");

      const highlightsText = document.createElement("span");
      highlightsText.innerText = `${project.highlights}`;
      highlightsText.classList.add("highlights");

      highlights.appendChild(highlightsTitle);
      highlights.appendChild(highlightsText);
    }

    // ******************************* CREATE SEE LIVE & SOURCE CODE BUTTONS *******************************
    const buttonWrapper = document.createElement("div");
    {
      buttonWrapper.classList.add("project-button-wrapper");

      const buttons = [];
      let anchorSeeLive;
      let firstSourceCode;
      let secondSourceCode;

      if (project.seeLiveLink) {
        anchorSeeLive = document.createElement("a");
        anchorSeeLive.setAttribute("href", project.seeLiveLink);
        anchorSeeLive.innerText = "See Live";
        buttons.push(anchorSeeLive);
      }

      if (project.firstSourceCodeLink) {
        firstSourceCode = document.createElement("a");
        firstSourceCode.setAttribute("href", project.firstSourceCodeLink);
        firstSourceCode.innerText = project.firstSourceCodeLabel;
        firstSourceCode.classList.add("plain-text-button");
        buttons.push(firstSourceCode);
      }

      if (project.secondSourceCodeLink) {
        secondSourceCode = document.createElement("a");
        secondSourceCode.setAttribute("href", project.secondSourceCodeLink);
        secondSourceCode.innerText = project.secondSourceCodeLabel;
        secondSourceCode.classList.add("plain-text-button");
        buttons.push(secondSourceCode);
      }

      buttons.forEach((button) => {
        button.setAttribute("rel", "noreferrer");
        button.setAttribute("target", "blank");
        button.classList.add("cta-btn");
        buttonWrapper.appendChild(button);
      });
    }

    // ******************************* FINISH ADDING PROJECT TEXT & BUTTONS *******************************
    projectTextWrapper.appendChild(title);
    projectTextWrapper.appendChild(description);
    projectTextWrapper.appendChild(highlights);
    projectTextWrapper.appendChild(buttonWrapper);

    colTextAndButtons.appendChild(projectTextWrapper);
    row.appendChild(colTextAndButtons);
  }

  // ******************************* ADD PROJECT IMAGE *******************************
  {
    const colImage = document.createElement("div");
    {
      colImage.classList.add("col-sm-12");
      colImage.classList.add("col-lg-8");
    }

    const projectImageWrapper = document.createElement("div");
    {
      projectImageWrapper.classList.add("project-wrapper__image");
      projectImageWrapper.classList.add("load-hidden");
    }

    const anchorImage = document.createElement("a");
    {
      anchorImage.setAttribute("rel", "noreferrer");
      anchorImage.setAttribute("target", "blank");
      anchorImage.setAttribute(
        "href",
        project.imageLink ? project.imageLink : project.seeLiveLink
      );
    }

    const jsTiltWrapper = document.createElement("div");
    {
      jsTiltWrapper.classList.add("thumbnail");
      jsTiltWrapper.classList.add("rounded");
      jsTiltWrapper.classList.add("js-tilt");
      jsTiltWrapper.setAttribute("data-tilt", "true");
      jsTiltWrapper.setAttribute("data-tilt-max", "4");
      jsTiltWrapper.setAttribute("data-tilt-glare", "true");
      jsTiltWrapper.setAttribute("data-tilt-max-glare", "0.5");
    }

    const img = document.createElement("img");
    {
      img.setAttribute("alt", `Project Banner Image for ${project.title}`);
      img.classList.add("project-img");
      img.classList.add("img-fluid");
      img.src = `${project.imagePath}`;
    }

    // ******************************* FINISH PROJECT IMAGE *******************************
    jsTiltWrapper.appendChild(img);
    anchorImage.appendChild(jsTiltWrapper);
    projectImageWrapper.appendChild(anchorImage);

    colImage.appendChild(projectImageWrapper);
    row.appendChild(colImage);
  }

  projectRoot.appendChild(row);
};

export default addProject;
